<template>
  <div >
    <div class="div-main">
      <div class="div-name">
        <label class="title">{{name}}下载</label>
      </div>
      <div >
        <img class="img-main" :src='icon'/>
      </div>
      <p class="end-p" v-show="false" >{{browseName}} --- {{ua}}</p>
      <div v-if="!showProgress">
        <el-button type="primary" round @click.native="downloadCountAdd()">下载</el-button>
        <p v-show="false"  style="margin-top: 10px">
          <a :href="apkPath" :download="apkName"
             class="title2" >下载</a>
        </p>
      </div>
      <div v-else>
        <el-progress type="circle" :percentage="progress" :stroke-width="10"
                     class="custom-progress"
                     :format="formatProgress"
        ></el-progress>
        <p class="end-p">正在打包中，请耐心等候...</p>
      </div>
      <p v-if="progress===100" class="end-p">打包成功，稍作等待，浏览器正在识别下载内容</p>
      <p v-if="showDownloadError" class="end-error">打包失败，请重新打包。<br/>如多次尝试后仍存在错误，请联系服务器管理员。</p>
    </div>
    <p class="end-p">© 2003-2020 慧源创新科技 Cloud 版权所有 <br/>粤ICP备18095928号</p>
  </div>
</template>

<script>

export default {
  name: 'Model',
  data () {
    return {
      name: '',
      icon: '',
      apkPath: '',
      apkName: '',
      alignApkPath: '',
      browseName: '',
      isDownloading: false,
      isPaused: false,
      progress: 0,
      fileSize: 0,
      chunkSize: 1 * 1024 * 1024, // 5MB
      chunks: [],
      controller: null,
      downloadedSize: 0,
      showProgress: false,
      showDownloadError: false,
      ua: '',
      test: false
    }
  },
  // 这里使用的vue
  created () {
    // 获取html
    var html = document.getElementsByTagName('html')[0]
    if (window.innerWidth < 768) {
      // 首次进入时获取屏幕宽度，宽度/750*100，手机端设计稿宽一般为750px，这里以750为基准调整基础大小，即当屏幕正好为750px时html字体大小为100px，p{font-size: 1rem}字体大小就为100px，屏幕宽为375px时，html50px、p50px，这里标签的宽高同样能使用rem表示
      html.style.fontSize = window.innerWidth / 750 * 100 + 'px'
    } else {
      html.style.fontSize = '16px'
    }
    // 实时获取改变html根元素字体大小
    window.addEventListener('resize', function () {
      if (window.innerWidth < 768) {
        html.style.fontSize = window.innerWidth / 750 * 100 + 'px'
        // console.log(window.innerWidth/750*100 + "px");
      } else {
        html.style.fontSize = '16px'
      }
    })
    this.name = this.$route.query.name
    this.icon = this.$global.baseURL.concat(this.$route.query.icon)

    this.apkPath = this.$global.baseURL.concat(this.$route.query.apkPath).replace(':8084', '')
    // 方便本地测试
    this.apkPath = this.testLocalUrl(this.apkPath)
    this.alignApkPath = this.$global.baseURL.concat('downloadFile/apk?filename=').concat(this.$route.query.apkPath)
    this.alignApkPath = this.testLocalUrl(this.alignApkPath)
    console.log('this.$route.query.apkPath：' + this.$route.query.apkPath)
    console.log('this.alignApkPath：' + this.alignApkPath)
    // https://app.hy-chip.com/hyAppView/model?name=HFun%20Pilot&icon=img%2Fhfun_pilot.png&apkPath=apkFiles%2Fhfun_pilot.apk
    // http://localhost:8081/hyAppView/model?name=HFun%20Pilot&icon=img%2Fhfun_pilot.png&apkPath=apkFiles%2Fhfun_pilot.apk
    this.browseName = this.detectMobileBrowser()
    this.apkName = this.apkPath.substring(this.apkPath.lastIndexOf('/') + 1)
  },
  methods: {
    testLocalUrl (url) {
      if (this.test) {
        return url.replace('127.0.0.1', '192.168.0.128')
          .replaceAll(':8080', '')
          .replace('http:', 'https:')
      } else {
        return url
      }
    },
    detectMobileBrowser () {
      const ua = navigator.userAgent.toLowerCase()
      this.ua = ua
      const brands = [
        {name: 'Huawei', pattern: /huaweibrowser|hwbrowser/},
        {name: 'Xiaomi', pattern: /miuibrowser|xiaomi/},
        {name: 'OPPO', pattern: /heytapbrowser/},
        {name: 'vivo', pattern: /vivobrowser|vivo/},
        {name: 'OnePlus', pattern: /oneplus/},
        {name: 'Honor', pattern: /honorbrowser/},
        {name: 'Redmi', pattern: /redmi/},
        {name: 'Windows ', pattern: /windows/}// ,
        // {name: 'Android ', pattern: /android/}
      ]
      for (const brand of brands) {
        if (brand.pattern.test(ua)) return brand.name
      }
      return 'Unknown'
    },
    downloadCountAdd () {
      // window.location.href = this.apkPath
      // window.open(this.apkPath)
      console.log('downloadCountAdd', this.apkName)
      // detectMobileBrowser1 apk:OPPO/vivo zip:Chrome、Huawei、Honor
      if (this.browseName !== 'Unknown') {
        this.clickADownloadBrowse()
      } else {
        this.showProgress = true
        this.startDownload()
      }
      this.$axios({
        url: this.$global.baseURL.concat('main/downloadCountAdd'),
        method: 'post',
        data: {url: this.apkPath}
      }).then(successResponse => {
        // this.downloadApkPath()
      })
    },
    formatProgress (progress) {
      return `${progress.toFixed(2)}%`
    },
    clickADownloadPhone () {
      let downloadElement = document.createElement('a')
      downloadElement.setAttribute('type', 'application/vnd.android.package-archive')
      downloadElement.href = this.apkPath
      downloadElement.download = this.apkName
      downloadElement.setAttribute('download', this.apkName)
      document.body.appendChild(downloadElement)
      // 点击下载
      downloadElement.click()
      // 下载完成移除元素
      document.body.removeChild(downloadElement)
    },
    clickADownloadBrowse () {
      console.log('downloadCountAdd')
      let downloadElement = document.createElement('a')
      downloadElement.setAttribute('type', 'application/vnd.android.package-archive')
      // this.apkPath = this.apkPath.replace('127.0.0.1', '192.168.0.128').replaceAll(':8080', '')
      // downloadElement.href = this.apkPath
      downloadElement.href = this.apkPath
      // 下载后文件名
      downloadElement.download = this.apkName
      // downloadElement.download = name
      console.log('downloadApkPath', this.apkPath, this.name, downloadElement.name, downloadElement.download)

      document.body.appendChild(downloadElement)
      // 点击下载
      downloadElement.click()
      // 下载完成移除元素
      setTimeout(() => {
        document.body.removeChild(downloadElement)
      }, 100)
    },
    async startDownload () {
      this.isDownloading = true
      this.showDownloadError = false
      this.isPaused = false
      this.progress = 0
      this.chunks = []
      this.downloadedSize = 0

      try {
        // 获取文件大小
        const fileSize = await this.getFileSize()
        this.fileSize = fileSize

        // 计算分片数量
        const totalChunks = Math.ceil(fileSize / this.chunkSize)

        // 创建AbortController用于取消下载
        this.controller = new AbortController()

        // 并发下载所有分片
        const promises = []
        for (let i = 0; i < totalChunks; i++) {
          const start = i * this.chunkSize
          const end = Math.min(start + this.chunkSize - 1, fileSize - 1)
          promises.push(this.downloadChunk(start, end, i))
        }

        await Promise.all(promises)
        // 合并所有分片
        await this.mergeChunks()
        if (this.progress === 100) {
          this.showProgress = false
        }
        // this.$emit('download-complete')
      } catch (error) {
        console.error('下载失败:', error)
        // this.$emit('download-error', error)
        this.showProgress = false
        this.showDownloadError = true
      } finally {
        this.isDownloading = false
      }
    },
    async getFileSize () {
      const response = await fetch(this.$global.baseURL.concat('downloadFile/fileSize?filename=').concat(this.$route.query.apkPath), {
        method: 'HEAD'
      })

      if (!response.ok) {
        throw new Error('无法获取文件信息')
      }

      const contentLength = response.headers.get('Content-Length')
      if (!contentLength) {
        throw new Error('无法获取文件大小')
      }
      console.log('getFileSize2', contentLength)
      return parseInt(contentLength)
    },
    async downloadChunk (start, end, index) {
      if (this.isPaused) {
        return
      }

      const response = await fetch(this.$global.baseURL.concat('downloadFile/apk?filename=').concat(this.$route.query.apkPath), {
        headers: {
          'Range': `bytes=${start}-${end}`
        },
        signal: this.controller.signal
      })
      if (!response.ok) {
        this.isPaused = true
        throw new Error(`分片${index}下载失败`)
      }

      const blob = await response.blob()
      this.chunks[index] = blob
      this.downloadedSize += blob.size
      this.progress = (this.downloadedSize / this.fileSize) * 100
    },

    async mergeChunks () {
      // 确保所有分片按顺序排列
      const sortedChunks = this.chunks
        .filter(chunk => chunk !== undefined)
        .sort((a, b) => {
          return this.chunks.indexOf(a) - this.chunks.indexOf(b)
        })

      const mergedBlob = new Blob(sortedChunks)
      const url = URL.createObjectURL(mergedBlob)

      // 创建下载链接
      const a = document.createElement('a')
      a.href = url
      a.download = this.getFileNameFromUrl()
      document.body.appendChild(a)
      a.click()

      // 清理
      setTimeout(() => {
        document.body.removeChild(a)
        URL.revokeObjectURL(url)
      }, 100)
    },

    getFileNameFromUrl () {
      return this.apkPath.split('/').pop() || 'downloaded-file'
    },

    cancelDownload () {
      if (this.controller) {
        this.controller.abort()
      }
      this.isDownloading = false
      this.isPaused = false
    }
  },
  beforeDestroy () {
    this.cancelDownload()
  }
}

</script>

<style scoped>
.div-main{
  border:1px solid #66CCFF;
  border-radius: 20px;
  width: 94%;
  margin-top: 20%;
  margin-left: 3%;
  margin-right: 3%;
  text-align: center;
  padding-bottom: 10%;
}
.div-main div{
  text-align: center;
}
.div-name{
  width: 100%;
  height:120px;
  background: #66CCFF;
  text-align: center;
  border-top-left-radius: 20px;
  border-top-right-radius: 20px;
  -moz-border-radius-topleft: 20px;
  -moz-border-radius-topright: 20px;
  padding-top: 60px;
}
.title{
  font-size: 24px;
  color: white;
}
.img-main{
  margin-top: -40px;
  width: 160px;
  height: 160px;
}
.el-button{
  background: #66CCFF;
  border-color: #66CCFF;
  width: 200px;
  font-size: 16px;
}
.el-button:hover{
  background: #1188FF;
  color: white;
}
.end-p{
  font-size: 14px;
  text-align: center;
}
.end-error{
  font-size: 14px;
  text-align: center;
  color: red;
}
.custom-progress{
  margin-top: 10px;
}
.custom-progress >>> .el-progress__text {
  font-size: 24px !important; /* 设置字体大小 */
}
.title2{
  /* 去掉下划线 */
  text-decoration: none;

  /* 字体颜色白色 */
  color: white;

  /* 填充30px（上下左右） */
  padding: 10px 80px 10px 80px;
  font-size: 15px;
  /* 圆角30px */
  border-radius: 30px;

  /* 底色 #66CCFF */
  background-color: #66CCFF;

  /* 可选：添加一些交互效果 */
  display: inline-block;
  font-weight: bold;
  transition: all 0.3s ease;
}
.title2:hover {
  background-color: #1188FF;
}
/* 点击效果（可选） */
.title2:active {
  transform: translateY(0);
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.2);
}
</style>



// WEBPACK FOOTER //
// src/components/Model.vue